import { useCallback } from "react";
import useAxios from "@Apis/useAxios";
import {
	GET_CUSTOMER_RESOURCE_OVERVIEW_API,
	POST_CUSTOMER_RESOURCE_API,
	PUT_CUSTOMER_RESOURCE_API,
	PUT_CUSTOMER_RESOURCE_ENABLE_API,
	GET_CUSTOMER_RESOURCE_SORT_API,
	POST_CUSTOMER_RESOURCE_SORT_API,
} from "@Apis/apiPath";

const useCustomerResourceApi = () => {
	const Axios = useAxios();

	const getCustomerResourceOverviewApi = useCallback(
		async (params) => {
			let url = GET_CUSTOMER_RESOURCE_OVERVIEW_API;
			
			// 若有參數，建立查詢字串
			if (params && Object.keys(params).length > 0) {
				const queryParams = new URLSearchParams();
				Object.entries(params).forEach(([key, value]) => {
					if (value !== undefined && value !== null && value !== '') {
						queryParams.append(key, value);
					}
				});
				url += '?' + queryParams.toString();
			}
			
			const resp = await Axios.get(url);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const postCustomerResourceApi = useCallback(
		async params => {
			const resp = await Axios.post(POST_CUSTOMER_RESOURCE_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const putCustomerResourceApi = useCallback(
		async (sourceID, params) => {
			const resp = await Axios.put(PUT_CUSTOMER_RESOURCE_API(sourceID), params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const putCustomerResourceEnableApi = useCallback(
		async (sourceID, params) => {
			const resp = await Axios.put(PUT_CUSTOMER_RESOURCE_ENABLE_API(sourceID), params);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

    const getCustomerResourceSortApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_CUSTOMER_RESOURCE_SORT_API);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const postCustomerResourceSortApi = useCallback(

        async (params) => {
            const resp = await Axios.post(POST_CUSTOMER_RESOURCE_SORT_API, params);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

	return {
		getCustomerResourceOverviewApi,
		postCustomerResourceApi,
		putCustomerResourceApi,
		putCustomerResourceEnableApi,
		getCustomerResourceSortApi,
		postCustomerResourceSortApi,
	};
};

export default useCustomerResourceApi;
